import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dialog-no-connection',
  templateUrl: './dialog-no-connection.component.html',
  styleUrls: ['./dialog-no-connection.component.scss']
})
export class DialogNoConnectionComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit(): void {
  }

  refresh(): void {
    window.location.reload();
  }
}
